module.exports = __webpack_public_path__ + "img/sb_1@2x.b8a171f6.png";